import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';

import { AgeVerificationSelectors } from '../store/age-verification.slice';

@Injectable({ providedIn: 'root' })
export class AgeUnverifiedGuard {
  constructor(private store: Store, private router: Router) {}

  canActivateChild(): Observable<boolean> {
    const ageVerifiedBefore = !!localStorage.getItem('ageVerified');
    return this.store.pipe(
      select(AgeVerificationSelectors.selectAgeVerified),
      map((isVerified: boolean): boolean => {
        if (!isVerified && !ageVerifiedBefore) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      }),
      take(1)
    );
  }
}
